export const TRM_TYPES = {
  STATETRM: "[STATUS] TRM"
};
